import styled from 'styled-components'

import colors from '@settings/styleSettings'
import Modal from 'styled-react-modal'

export const Container = Modal.styled`
  font-family: 'Circular-Std';
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: absolute;
  height: 100%;
  width: 480px;
  max-width: 100vw;
  right: 0;
  top: 0;
  background-color: ${colors.background};
  overflow: hidden;

  @media (max-width: 375px) {
    max-width: 100%;
    width: 100%;
  }

  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  @-webkit-keyframes fadeInRight {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
  @keyframes fadeInRight {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
  & > div {
    font-family: Circular-Std;
  }
`
export const Section = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
`

export const ContentContainer = styled.div`
  border-top: 2px solid ${colors.grayBackground};
  margin: 0 24px;
  background-color: ${colors.background};
  font-size: 16px;
  font-weight: 600;
  color: ${colors.strongGray};
  padding: 4px;
  overflow-y: auto;
  flex: 1;
  scrollbar-width: thin;
  scrollbar-color: ${colors.softGray} transparent;

  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${colors.softGray};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: ${colors.placeholder};
  }
`
export const Label = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.strongGray};
  margin-bottom: 4px;
`

export const Value = styled.div`
  min-height: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 450;
  padding: 10px 20px;
  background-color: ${colors.softGrayBackground};
  color: ${colors.strongGray};
  line-height: 1.4;
  border-radius: 12px;
  border: 1px solid ${colors.softGray};
  margin-bottom: 32px;
  white-space: pre-line;
  word-break: break-word;
  overflow-wrap: break-word;
`

export const ErrorValue = styled(Value)`
  background-color: ${colors.softRed};
  color: ${colors.strongRed};
  border-color: ${colors.strongRed};
`

export const ResultItem = styled.div`
  margin-bottom: 8px;
`

export const ResultKey = styled.span`
  font-weight: bold;
`

export const CollectionCard = styled.div`
  background-color: ${({ selected }) => (selected ? colors.softGreen : colors.softGrayBackground)};
  border: 1px solid ${({ selected }) => (selected ? colors.strongGreen : colors.softGray)};
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 10px;
  font-weight: 450;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover {
    border-color: ${colors.strongGreen};
  }
`

export const CollectionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const CollectionRadio = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid ${({ selected }) => (selected ? colors.strongGreen : colors.softGray)};
  background-color: ${colors.background};
  flex-shrink: 0;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(${({ selected }) => (selected ? 1 : 0)});
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${colors.strongGreen};
    transition: transform 0.15s ease;
  }
`

export const CollectionInfo = styled.div`
  flex: 1;
  min-width: 0;
`

export const CollectionTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${colors.strongGray};
`

export const CollectionMeta = styled.div`
  font-size: 13px;
  color: ${colors.strongGray};
  margin-top: 2px;
`

export const CollectionBadge = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: ${colors.strongRed};
  background-color: ${colors.softRed};
  padding: 4px 8px;
  border-radius: 8px;
  white-space: nowrap;
`

export const ImportFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
  padding-bottom: 24px;
`

export const BeneficiaryName = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${colors.strongGreen};
  background-color: ${colors.softGreen};
  padding: 10px 16px;
  border-radius: 12px;
  border: 1px solid ${colors.strongGreen};
  margin-bottom: 12px;
`

export const ConfirmBanner = styled.div`
  background-color: ${colors.softRed};
  color: ${colors.strongRed};
  font-size: 13px;
  font-weight: 600;
  padding: 12px 16px;
  border-radius: 12px;
  margin-top: 8px;
`

export const CollectionsEmpty = styled.div`
  padding: 16px;
  font-size: 14px;
  font-weight: 450;
  color: ${colors.strongGray};
  text-align: center;
  background-color: ${colors.softGrayBackground};
  border: 1px solid ${colors.softGray};
  border-radius: 12px;
  margin-bottom: 16px;
`

export const SearchArea = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  margin-bottom: 16px;

  & > :first-child {
    flex: 1;
  }
`

export const SearchButton = styled.button`
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: white;
  background-color: ${colors.strongGreen};
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  min-width: 80px;
  height: 42px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
